import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Breadcrumb } from 'react-bootstrap';
const LABEL_MAP = {
    dashboard: 'Dashboard',
    freetools: 'Tools',
    recycle: 'Knowledge Base',
    settings: 'Settings',
};

export default function HeaderBreadcrumb({ hide }) {
    const location = useLocation();
    const crumbs = useMemo(() => {
        const parts = location.pathname.split('/').filter(Boolean);
        let cumulative = '';
        return parts.map((part, i) => {
            cumulative += `/${part}`;
            return {
                label: LABEL_MAP[part] ?? part.replace(/^\w/, c => c.toUpperCase()),
                path: cumulative,
                active: i === parts.length - 1,
            };
        });
    }, [location.pathname]);

    if (hide) {
        return null;
    }

    return (
        <Breadcrumb className="mb-0 display-flex align-items-center">
            {crumbs.map(c =>
                c.active ? (
                    <Breadcrumb.Item active key={c.path} className="mb-0 display-flex align-items-center">
                        <span className='color_white font_14 font_400 mb-0'>{c.label}</span>
                    </Breadcrumb.Item>
                ) : (
                    <Breadcrumb.Item
                        linkAs={Link}
                        linkProps={{ to: c.path }}
                        key={c.path}
                        className="mb-0"
                    >
                        <span className='color_white font_14 font_400'>{c.label}</span>
                    </Breadcrumb.Item>
                )
            )}
        </Breadcrumb>
    );
}
